import { useEffect, useState, useContext } from 'react';
import { UserContext } from '../../UserContext';
import usePermisos from '../../hooks/usePermisos';
import NoPermissions from '../NoPermissions/NoPermissions';
import Loader from '../../Layout/Loaders/Loader';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import WelcomeBanner from './WelcomeBanner';
import QuickActions from './QuickActions';
import { 
    CalendarDaysIcon, 
    ClockIcon,
    UserCircleIcon 
} from '@heroicons/react/24/outline';

// Permisos requeridos para ver el dashboard
const PERMISOS_REQUERIDOS = ['appointments_list_read'];

const Dashboard = () => {
    const { loading: loadingPermisos, tienePermiso } = usePermisos(PERMISOS_REQUERIDOS);

    // Mostrar loader mientras se cargan permisos
    if (loadingPermisos) {
        return <Loader />;
    }

    // Mostrar mensaje de sin permisos
    if (!tienePermiso('appointments_list_read')) {
        return <NoPermissions />;
    }

    return (
        <div>
            <div className="container-admin-menu">
                <Breadcrumb hasButton={false} hasFilters={false} />
            </div>
            <div className="container-admin-container">
                <div className="container-admin">
                    {/* Barra de Bienvenida */}
                    <WelcomeBanner />

                    {/* Accesos Rápidos */}
                    <QuickActions />

                    {/* Área de contenido - Widgets y Métricas */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {/* Placeholder para tarjetas futuras */}
                        <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200">
                            <div className="flex items-center justify-center h-48">
                                <div className="text-center">
                                    <CalendarDaysIcon className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                                    <p className="text-gray-400 font-medium">Próximamente</p>
                                    <p className="text-gray-400 text-sm">Métricas y estadísticas</p>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200">
                            <div className="flex items-center justify-center h-48">
                                <div className="text-center">
                                    <ClockIcon className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                                    <p className="text-gray-400 font-medium">Próximamente</p>
                                    <p className="text-gray-400 text-sm">Citas del día</p>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200">
                            <div className="flex items-center justify-center h-48">
                                <div className="text-center">
                                    <UserCircleIcon className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                                    <p className="text-gray-400 font-medium">Próximamente</p>
                                    <p className="text-gray-400 text-sm">Actividad reciente</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
